<script>
import appConfig from '@src/app.config'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import requestFunctions from "@src/functions/requestFunctions";

export default {

	page: {
		title: 'Диалог',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect, VuePerfectScrollbar },

	data() {
        return {
			title: 'Диалог',
			items: [
				{
					text: 'Личный кабинет',
					href: '/account',
				},
                {
                    text: 'Диалог',
                    active: true,
                },
			],
            messages: [],
            message: null,
            chatWindowHeight: 'calc(100vh - 410px)',
            clientWindowHeight: 'calc(100vh - 225px)',
            dialog_uuid: '',
            dialog_id: '',
            trackBy: 'id',
            user_uuid: '',
            profile_uuid: '',
            phone: '',
            email: '',
            name1: '',
            name2: '',
            name3: '',
            inner_number : null,
            initLanguage: [],
            language: null,
            languages_options: [
                {id: 'russian', name: 'Русский'},
            ],
            user: null,
            profile: null,
            user_name: null,
            channel_name: null,
            source_url: null,
            user_email: null,
            user_phone: null,
            user_ava: '',
            initRole: [],
            role: null,
            roles_options: [
                {id: 'member', name: 'Пользователь'},
                {id: 'administrator', name: 'Администратор'},
            ],
            initType: [],
            type: null,
            types_options: [
                {id: 'manager',    name: 'Менеджер'},
                {id: 'consultant', name: 'Консультант'},
                {id: 'customer',   name: 'Клиент'},
                {id: 'administrator', name: 'Администратор'},
            ],
            initStatus: [],
            status: null,
            status_options: [
                {id: 'active', name: 'Активен'},
                {id: 'wait', name: 'Ожидает активации'},
                {id: 'blocked', name: 'Заблокирован'},
            ],
            isSubmitErrorData: null,
            alertMessage: null,
            alertVariant: null
		}
	},

    watch: {
        messages: {
            immediate: true,
            handler(values) {

            }
        },
        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        },
        initType: {
            immediate: true,
            handler(values) {
                this.type = this.types_options.filter(x => values.includes(x[this.trackBy]));
                this.type = this.type[0];
            }
        },
        initRole: {
            immediate: true,
            handler(values) {
                this.role = this.roles_options.filter(x => values.includes(x[this.trackBy]));
                this.role = this.role[0];
            }
        },
        initLanguage: {
            immediate: true,
            handler(values) {
                this.language = this.languages_options.filter(x => values.includes(x[this.trackBy]));
                this.language = this.language[0];
            }
        }
    },

	computed: {
        dialogs_messages_list_data(){
            return this.$store.getters['dialogsMessages/GET_DIALOGS_MESSAGES_LIST_DATA'];
        },
        dialogs_item(){
            return this.$store.getters['dialogs/GET_DIALOGS_ITEM'];
        },
        user_item(){
            let user = this.$store.getters['users/GET_USERS_ITEM'];
            return user;
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            let user = session.user ? session.user : null;
            return user;
        },
	},

	async mounted() {

        this.dialog_uuid = this.$route.params.dialog_uuid ? this.$route.params.dialog_uuid : '';

        if(this.dialog_uuid !== ''){

            let data_send = {
                'uuid' : this.dialog_uuid,
            }

            await this.$store.dispatch('dialogs/FETCH_DIALOGS_ITEM', data_send);
            let dialog = this.dialogs_item;

            this.dialog_id = dialog.id ? dialog.id : '';

            this.user_uuid = dialog.user && dialog.user.uuid ? dialog.user.uuid : '';
            this.user = dialog.user ? dialog.user : '';
            this.profile = dialog.profile ? dialog.profile : '';
            this.source_url = dialog.source_url ? dialog.source_url : '';

            if(this.user.email && this.user.email !== null){
                this.user_name = this.user.email;
                this.user_email = this.user.email;
            }

            if(this.user.telegram_login && this.user.telegram_login !== null){
                this.user_name = this.user.telegram_login;
            }

            if(this.user.phone !== null){
                this.user_name = this.user.phone;
                this.user_phone = this.user.phone;
            }

            if(this.profile.fullname){
                this.user_name = this.profile.fullname;
            }

            if(this.user === null){
                this.user_name = 'без имени';
            }

            if(dialog.channel && dialog.channel.name){
                this.channel_name = dialog.channel.name;
            }

            if(this.user.avatar_img !== null){
                this.user_ava = this.user.avatar_img;
            } else {
                this.user_ava = require('@assets/images/users/avatar-7.jpg');
            }


            // Получаем данные пользователя
            if(this.user_uuid !== ''){

                let data_send = {
                    'uuid' : this.user_uuid,
                    'with' : 'profile'
                }

                await this.$store.dispatch('users/FETCH_USERS_ITEM', data_send);

                let user = this.user_item;

                this.profile_uuid = user.profile && user.profile.uuid ? user.profile.uuid : '';
                this.phone = user.phone ? user.phone : '';
                this.inner_number = user.inner_number ? user.inner_number : '';
                this.email = user.email ? user.email : '';
                this.name1 = user.profile && user.profile.name1 ? user.profile.name1 : '';
                this.name2 = user.profile && user.profile.name2 ? user.profile.name2 : '';
                this.name3 = user.profile && user.profile.name3 ? user.profile.name3 : '';
                this.language = user.language ? user.language : '';
                this.initLanguage = [this.language];
                this.role  = user.role ? user.role : '';
                this.initRole = [this.role];
                this.type  = user.type ? user.type : '';
                this.initType = [this.type];
                this.status = user.status ? user.status : '';
                this.initStatus = [this.status];

            }
        }

        await this.getMessagesList();

        setInterval(() =>{
            this.updateMessagesList()
        }, 3000)
	},

	methods: {

        async updateMessagesList(){

            let num = this.dialogs_messages_LIST_DATA.length - 1;

            if(num > 0) {

                let last_message = this.dialogs_messages_LIST_DATA[num];
                let last_message_id = last_message.id;

                // Обновляем список сообщения для выбранного диалога
                let data_send = {
                    'dialog_id': this.dialog_id,
                    'last_message_id': last_message_id
                }

                let result = await this.$store.dispatch('dialogsMessages/FETCH_DIALOGS_MESSAGES_LIST', data_send);

                if(result !== false) {
                    this.$refs.chat.$el.scrollTop = this.$refs.chat_messages.clientHeight;
                }
            }
        },

	    async getMessagesList(){

            // Получаем список сообщения для выбранного диалога
            let data_send = {
                'dialog_id' : this.dialog_id,
            }

            await this.$store.dispatch('dialogsMessages/FETCH_DIALOGS_MESSAGES_LIST', data_send);

            this.$refs.chat.$el.scrollTop = this.$refs.chat_messages.clientHeight;
        },

	    async sendMessage(){

	        let message  = this.message;
            this.message = '';

            let data_send = {
                'dialog_uuid' : this.dialog_uuid,
                'message'     : message
            };

            let result = await this.$store.dispatch('dialogsMessages/FETCH_DIALOGS_MESSAGES_CREATE', data_send);

            await this.updateMessagesList();
        },

        async saveUser(){

            let data_send = {};

            let result = '';

            if(this.user_uuid === ''){

                let data_send = {
                    'uuid'     : this.user_uuid,
                    'email'    : this.email,
                    'phone'    : this.phone,
                    'language' : this.language && this.language.id ? this.language.id : null,
                    'name1'    : this.name1,
                    'name2'    : this.name2,
                    'name3'    : this.name3,
                    'inner_number' : this.inner_number,
                    'role'   : this.role && this.role.id ? this.role.id : null,
                    'type'   : this.type && this.type.id ? this.type.id : null,
                    'status' : this.status && this.status.id ? this.status.id : null,
                    'payment_type' : 'after',
                };

                result = await this.$store.dispatch('users/FETCH_USERS_CREATE', data_send);

            } else {

                let data_send_user = {
                    'uuid'     : this.user_uuid,
                    'email'    : this.email,
                    'phone'    : this.phone,
                    'inner_number' : this.inner_number,
                    'role'   : this.role && this.role.id ? this.role.id : null,
                    'type'   : this.type && this.type.id ? this.type.id : null,
                    'status' : this.status && this.status.id ? this.status.id : null,
                    'language' : this.language && this.language.id ? this.language.id : null,
                };
                let user_update_result = await this.$store.dispatch('users/FETCH_USERS_UPDATE', data_send_user);

                let data_send_profile = {
                    'uuid'  : this.profile_uuid,
                    'name1' : this.name1,
                    'name2' : this.name2,
                    'name3' : this.name3,
                };
                let profile_update_result = await this.$store.dispatch('profiles/FETCH_PROFILES_UPDATE', data_send_profile);

                if (user_update_result === false || profile_update_result === false){
                    result = false;
                }
            }

            if(result === false){
                this.isSubmitErrorData = true;
                this.alertMessage = 'При обновлении данных возникла ошибка';
                this.alertVariant = 'danger';
            } else {
                this.isSubmitErrorData = true;
                this.alertMessage = 'Информация успешно обновлена';
                this.alertVariant = 'success';
            }
        },

        async updateDialogStatus(status){

            let data_send = {
                'uuid'   : this.dialog_uuid,
                'status' : status
            };
            let result = await this.$store.dispatch('dialogs/FETCH_DIALOGS_UPDATE', data_send);

            this.$router.push({ name: 'Dialogs'});
        },

        async deleteDialog(status){

            let data_send = {
                'uuid' : this.dialog_uuid
            };
            let result = await this.$store.dispatch('dialogs/FETCH_DIALOGS_DELETE', data_send);

            this.$router.push({ name: 'Dialogs'});
        }
	}
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <div class="row">

            <div class="col-7">

                <div class="card">
                    <div class="card-body">

                        <div class="media mb-4 mt-1">
                            <img v-show="user_ava !== null" :src="user_ava" class="d-flex mr-2 rounded-circle avatar-sm" alt="male" />

                            <div class="media-body" style="margin-left: 15px">
                                <div class="float-right">
                                    <div class="btn-group mb-2">
                                      <a href="javascript: void(0);" @click="updateDialogStatus('archive')" id="archive-tooltip" type="button" class="btn btn-light">
                                        <b-tooltip target="archive-tooltip">В архив</b-tooltip>
                                        <i class="uil uil-archive-alt"></i>
                                      </a>
                                      <a href="javascript: void(0);" @click="deleteDialog()" id="delete-tooltip" type="button" class="btn btn-light">
                                        <b-tooltip target="delete-tooltip">Удалить</b-tooltip>
                                        <i class="uil uil-trash-alt"></i>
                                      </a>
                                    </div>
                                </div>
                                <h6 class="m-0 font-14" style="font-size: 16px">{{ user_name }}</h6>
                                <small class="text-muted" v-show="user_phone !== null">{{ user_phone }}<br></small>
                                <small class="text-muted" v-show="user_email !== null">{{ user_email }}<br></small>
                                <small class="text-muted" v-show="channel_name !== null">Источник: {{ channel_name }}<br></small>
                                <small class="text-muted" v-show="source_url !== null"><a :href="source_url" target="_blank">{{ source_url }}</a></small>
                            </div>
                        </div>

                        <hr />

                        <VuePerfectScrollbar :style="`max-height:${chatWindowHeight}; height:${chatWindowHeight}`" ref="chat">
                            <ul class="conversation-list" style="height: auto !important;" ref="chat_messages">
                                <li
                                    v-for="(chat, index) in dialogs_messages_LIST_DATA"
                                    :key="chat.id"
                                    :class="(chat.owner === null) ? 'odd' : 'no_odd'"
                                    class="clearfix"
                                >
                                    <div class="chat-avatar" style="width: 57px">
                                        <img v-show="chat.user !== 'Бот' && chat.avatar === null" :src="require('@assets/images/users/avatar-7.jpg')" alt="male" />
                                        <img v-show="chat.user !== 'Бот' && chat.avatar !== null" :src="chat.avatar" alt="male" />
                                        <img v-show="chat.user === 'Бот'" :src="require('@assets/images/users/ava-bot256.png')" alt="male" />
                                    </div>
                                    <div class="conversation-text">
                                        <div class="ctext-wrap">
                                            <i>{{ chat.user }}</i>
                                            <p>{{ chat.text }}</p>
                                            <p style="color:#4d4d4d; font-size: 8px; line-height: 150% !important; margin-top: 5px; text-align: right;">{{ chat.created_at }}</p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </VuePerfectScrollbar>
                        <div class="position-relative chat-input" style="position: relative; margin-top: 15px;">
                            <input
                                v-model="message"
                                @keyup.enter="sendMessage"
                                type="text"
                                class="form-control"
                                placeholder="Ваше сообщение..."
                            />
                            <div class="chat-link" style="position: absolute; right: 10px; top: 10px">
                                <a href="javascript: void(0);" @click="sendMessage" class="p-1">
                                    <i class="uil-navigator"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>

            <div class="col-5">
                <div class="card">
                    <div class="card-body" :style="`overflow: scroll; max-height:${clientWindowHeight}; height:${clientWindowHeight}`">
                        <b-form
                            class="form-horizontal"
                            @submit.prevent="saveUser"
                        >
                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Фамилия"
                                        label-for="name3"
                                    >
                                        <b-form-input
                                            id="name3"
                                            v-model="name3"
                                            placeholder="Фамилия"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Имя"
                                        label-for="name1"
                                    >
                                        <b-form-input
                                            id="name1"
                                            v-model="name1"
                                            placeholder="Имя"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Отчество"
                                        label-for="name2"
                                    >
                                        <b-form-input
                                            id="name2"
                                            v-model="name2"
                                            placeholder="Отчество"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Номер телефона"
                                        label-for="phone"
                                    >
                                        <b-form-input
                                            id="phone"
                                            v-model="phone"
                                            placeholder="Номер телефона пользователя"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="E-mail адрес"
                                        label-for="email"
                                    >
                                        <b-form-input
                                            id="email"
                                            v-model="email"
                                            placeholder="E-mail адрес, если есть"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Роль пользователя"
                                        label-for="role"
                                    >
                                        <multiselect
                                            id="role"
                                            :track-by="trackBy"
                                            v-model="role"
                                            :options="roles_options"
                                            placeholder="Выберите из списка"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Тип пользователя"
                                        label-for="type"
                                    >
                                        <multiselect
                                            id="type"
                                            :track-by="trackBy"
                                            v-model="type"
                                            :options="types_options"
                                            placeholder="Выберите из списка"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Статус"
                                        label-for="status"
                                    >
                                        <multiselect
                                            id="status"
                                            :track-by="trackBy"
                                            v-model="status"
                                            :options="status_options"
                                            placeholder="Выберите из списка"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-alert
                                        v-model="isSubmitErrorData"
                                        :variant="alertVariant"
                                        dismissible
                                    >{{ alertMessage }}</b-alert
                                    >

                                    <b-form-group
                                        style="margin-top: 30px"
                                    >
                                        <button type="submit" class="btn btn-primary">Сохранить</button>
                                    </b-form-group>

                                </div>
                            </div>
                        </b-form>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>

        </div>
	</Layout>
</template>

<style>
    .no_odd .ctext-wrap {
        background: #f0f2fe !important;
        color: #1c1c1c !important;
        border-radius: 0px;
        -moz-border-radius-topright: 5px;
        -webkit-border-top-right-radius: 5px;
        border-top-right-radius: 5px;
        -moz-border-radius-bottomright: 5px;
        -webkit-border-bottom-right-radius: 5px;
        border-bottom-right-radius: 5px;
        -moz-border-radius-bottomleft: 5px;
        -webkit-border-bottom-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .no_odd .ctext-wrap::after {
        border-top-color: #f0f2fe !important;
        border-right-color: #f0f2fe !important;
    }
    .odd .ctext-wrap {
        background: #dbefff !important;
        border-radius: 0px;
        -moz-border-radius-topleft: 5px;
        -webkit-border-top-left-radius: 5px;
        border-top-left-radius: 5px;
        -moz-border-radius-bottomright: 5px;
        -webkit-border-bottom-right-radius: 5px;
        border-bottom-right-radius: 5px;
        -moz-border-radius-bottomleft: 5px;
        -webkit-border-bottom-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .odd .ctext-wrap::after {
        border-top-color: #dbefff !important;
        border-left-color: #dbefff !important;
    }
</style>
